module.exports = __webpack_public_path__ + "static/img/human-1.164617f0.png";